import { createStore } from 'redux';
import omit from 'lodash/omit';
import { GlobalState, reducers } from 'reducers';
import { epicMiddleware, middleware } from './middleware';
import rootEpic from '../epics';
import { resetTransientValues } from './resetTransientValues';

const LOCAL_STORAGE_KEY = 'state';
const saveToLocalStorage = (state: GlobalState) => {
  try {
    const serializedState = JSON.stringify(omit(state, 'evalSession'));
    localStorage.setItem(LOCAL_STORAGE_KEY, serializedState);
  } catch (e) {
    console.error(e);
  }
};

const loadFromLocalStorage = (): GlobalState | undefined => {
  try {
    const serializedState = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (serializedState === null) {
      return undefined;
    }
    const state = JSON.parse(serializedState) as GlobalState;
    resetTransientValues(state);
    return state;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

const store = createStore(reducers, loadFromLocalStorage(), middleware);

store.subscribe(() => saveToLocalStorage(store.getState()));

export default store;

// Export types for typed hooks
export type AppStore = typeof store;
export type AppDispatch = AppStore['dispatch'];

epicMiddleware.run(rootEpic);
